import { render, staticRenderFns } from "./mobile-record-list.vue?vue&type=template&id=23eb4151&scoped=true&"
import script from "./mobile-record-list.vue?vue&type=script&lang=js&"
export * from "./mobile-record-list.vue?vue&type=script&lang=js&"
import style0 from "./mobile-record-list.vue?vue&type=style&index=0&id=23eb4151&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb4151",
  null
  
)

export default component.exports